const menuItems = [
  
  {
    name: 'general',
    items: [
      {
        name: 'home',
        to: '/'
        //  icon : <IconSetting />
      },
    ]
  },

 
];

export default menuItems;
